export default __webpack_public_path__ + "static/media/shopify.98a2210c.svg";